import { CURRENCY_TYPE, SESSIONS_API } from 'constants/AppConstants';

const generateCaptureContext = async (currencyTypeId) => {
  try {
    const response = await fetch(SESSIONS_API.replace(':currencyType', CURRENCY_TYPE[currencyTypeId]), {
      method: 'GET',
    });
    const responseData = response.json();
    return responseData;
  } catch (error) {
    return { ok: false, json: { errorDescription: 'Internal Server Error' } };
  }
};

export default generateCaptureContext;
